'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getHostName = exports.getProducerAppUrl = exports.getManagerAppUrl = exports.getCreatorAppUrl = exports.getBrandAppUrl = exports.getMarketplaceUrl = exports.getContentManagerUrl = exports.getMatchingUrl = exports.getVaasUrl = undefined;

var _urls = require('../config/data/urls');

var _domain = require('../config/enums/domain');

var _window = require('../test-helpers/mock/window');

var _env = require('./env');

var getVaasUrl = exports.getVaasUrl = function getVaasUrl() {
    if ((0, _env.isDevelopment)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.vaasBaseUrls[_domain.Domain.DEVELOPMENT];
    }
    if ((0, _env.isTeam)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.vaasBaseUrls[_domain.Domain.TEAM];
    }
    if ((0, _env.isStaging)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.vaasBaseUrls[_domain.Domain.STAGING];
    }
    return "" + _urls.HTTP_SCHEMA + _urls.vaasBaseUrls[_domain.Domain.PRODUCTION];
};
var getMatchingUrl = exports.getMatchingUrl = function getMatchingUrl() {
    if ((0, _env.isDevelopment)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.matchingBaseUrls[_domain.Domain.DEVELOPMENT];
    }
    if ((0, _env.isTeam)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.matchingBaseUrls[_domain.Domain.TEAM];
    }
    if ((0, _env.isStaging)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.matchingBaseUrls[_domain.Domain.STAGING];
    }
    return "" + _urls.HTTP_SCHEMA + _urls.matchingBaseUrls[_domain.Domain.PRODUCTION];
};
var getContentManagerUrl = exports.getContentManagerUrl = function getContentManagerUrl() {
    if ((0, _env.isDevelopment)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.contentManagerAppBaseUrls[_domain.Domain.DEVELOPMENT];
    }
    if ((0, _env.isTeam)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.contentManagerAppBaseUrls[_domain.Domain.TEAM];
    }
    if ((0, _env.isStaging)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.contentManagerAppBaseUrls[_domain.Domain.STAGING];
    }
    return "" + _urls.HTTP_SCHEMA + _urls.contentManagerAppBaseUrls[_domain.Domain.PRODUCTION];
};
var getMarketplaceUrl = exports.getMarketplaceUrl = function getMarketplaceUrl() {
    if ((0, _env.isDevelopment)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.marketplaceAppBaseUrls[_domain.Domain.DEVELOPMENT];
    }
    if ((0, _env.isTeam)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.marketplaceAppBaseUrls[_domain.Domain.TEAM];
    }
    if ((0, _env.isStaging)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.marketplaceAppBaseUrls[_domain.Domain.STAGING];
    }
    return "" + _urls.HTTP_SCHEMA + _urls.marketplaceAppBaseUrls[_domain.Domain.PRODUCTION];
};
var getBrandAppUrl = exports.getBrandAppUrl = function getBrandAppUrl() {
    if ((0, _env.isDevelopment)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.brandAppBaseUrls[_domain.Domain.DEVELOPMENT];
    }
    if ((0, _env.isTeam)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.brandAppBaseUrls[_domain.Domain.TEAM];
    }
    if ((0, _env.isStaging)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.brandAppBaseUrls[_domain.Domain.STAGING];
    }
    return "" + _urls.HTTP_SCHEMA + _urls.brandAppBaseUrls[_domain.Domain.PRODUCTION];
};
var getCreatorAppUrl = exports.getCreatorAppUrl = function getCreatorAppUrl() {
    if ((0, _env.isDevelopment)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.creatorAppBaseUrls[_domain.Domain.DEVELOPMENT];
    }
    if ((0, _env.isTeam)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.creatorAppBaseUrls[_domain.Domain.TEAM];
    }
    if ((0, _env.isStaging)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.creatorAppBaseUrls[_domain.Domain.STAGING];
    }
    return "" + _urls.HTTP_SCHEMA + _urls.creatorAppBaseUrls[_domain.Domain.PRODUCTION];
};
var getManagerAppUrl = exports.getManagerAppUrl = function getManagerAppUrl() {
    if ((0, _env.isDevelopment)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.managerAppBaseUrls[_domain.Domain.DEVELOPMENT];
    }
    if ((0, _env.isTeam)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.managerAppBaseUrls[_domain.Domain.TEAM];
    }
    if ((0, _env.isStaging)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.managerAppBaseUrls[_domain.Domain.STAGING];
    }
    return "" + _urls.HTTP_SCHEMA + _urls.managerAppBaseUrls[_domain.Domain.PRODUCTION];
};
var getProducerAppUrl = exports.getProducerAppUrl = function getProducerAppUrl() {
    if ((0, _env.isDevelopment)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.producerAppBaseUrls[_domain.Domain.DEVELOPMENT];
    }
    if ((0, _env.isTeam)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.producerAppBaseUrls[_domain.Domain.TEAM];
    }
    if ((0, _env.isStaging)()) {
        return "" + _urls.HTTP_SCHEMA + _urls.producerAppBaseUrls[_domain.Domain.STAGING];
    }
    return "" + _urls.HTTP_SCHEMA + _urls.producerAppBaseUrls[_domain.Domain.PRODUCTION];
};
var getHostName = exports.getHostName = function getHostName() {
    return _window.customWindow.mockHostname || window.location.hostname || '';
};
//# sourceMappingURL=url.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/helpers/url.js
// module id = 647
// module chunks = 0